import * as React from 'react'
import { ReactComponent as DefaultLogo } from '../../../assets/images/svg_icons/popup_placeholder/error-icon.svg'

function SvgComponent() {
  return <DefaultLogo />
}

export default SvgComponent
